import client from "./api/client";

export const needsLineupPerformer = (offer, eventPerformers) => (
  Boolean(offer.calendar_event?.id) && !offer.performer_id && !offer.performer?.id && (eventPerformers || []).length > 0
);

export const attachableLineup = (eventPerformers) => (eventPerformers || []).filter((p) => !p.offer?.id);

export const lineupLabel = (performer) => `${performer.artistable?.name} · ${performer.humanized_act_type}`;

export const attachPerformerToOffer = (teamId, offerId, performerId) => (
  client.patch(`/teams/${teamId}/offers/${offerId}.json`, { offer: { performer_id: performerId } })
);
